import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { environment } from '../../environments/environment';
import { DatabaseService } from './db-service';
import { DocumentReference, Member, ServiceYearMember } from '../models';
import { Gender } from '../enums';

@Injectable({
  providedIn: 'root'
})

export class ServiceYearMemberService {

    // Keeping collection name as memberGroups to avoid affecting existing reports
    // We can use new collection just by updating this variable 
    public collection: string = 'memberGroups'; // 'serviceYearMembers';

    constructor(
        private afstore: AngularFirestore,
        private dbservice: DatabaseService) {
    }

    /**
     * Initiate the login process for this user
     * @param churchRef reference of user church
     * @param ageGroup ageGroup that user serve
     */
    public getMembersGroups(churchRef: DocumentReference, ageGroupRef: DocumentReference) {
        if (ageGroupRef.displayName === 'All Age Groups') {
            return this.dbservice.getDocuments(this.collection, ref => ref
                .where('serviceYear', '==', environment.serviceYear)
                .where('church', '==', churchRef)
                .where('isActive', '==', true)
                .where('isDeleted', '==', false)
                .orderBy('ageGroup')
            );
        }

        return this.dbservice.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', environment.serviceYear)
            .where('church', '==', churchRef)
            .where('ageGroup', '==', ageGroupRef)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
            .orderBy('yearLevel')
        );
    }

    public getTeamMembersYearLevels(churchRef: DocumentReference, yearLevelList: DocumentReference[]) {
        if (yearLevelList == null) {
            return this.dbservice.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', environment.serviceYear)
            .where('church', '==', churchRef)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
        }
        return this.dbservice.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', environment.serviceYear)
            .where('church', '==', churchRef)
            .where('yearLevel', 'in', yearLevelList)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    public getTeamMembersYearLevelsByGender(churchRef: DocumentReference, yearLevelList: DocumentReference[], gender: Gender) {
        return this.dbservice.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', environment.serviceYear)
            .where('church', '==', churchRef)
            .where('yearLevel', 'in', yearLevelList)
            .where('gender.value', '==', gender)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    /**
     * Get Member from edit
     * @param memberId reference of member
     */
    public async getMemberGroup(memberId: string, memberFullName: string) {
        const memberRef = {
            reference: this.dbservice.doc(`members/${memberId}`).ref,
            displayName: memberFullName
        };

        return this.dbservice.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', environment.serviceYear)
            .where('member', '==', memberRef)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    // CRUD functions
    // // Create
    public async createMemberGroup(serviceYearMember: ServiceYearMember, member: Member) {
        serviceYearMember.member = {
            reference: this.dbservice.doc(`members/${member.id}`).ref,
            displayName: `${member.firstName} ${member.lastName}`
        };
        serviceYearMember.serviceYear = environment.serviceYear;
        this.afstore
                .collection(this.collection)
                .add(serviceYearMember);
    }

    public orderByMemberName( a: ServiceYearMember, b: ServiceYearMember ) {
        if ( a.member.displayName < b.member.displayName ) {
          return -1;
        }
        if ( a.member.displayName > b.member.displayName ) {
          return 1;
        }
        return 0;
    }
}
